import { TYPE } from '@/constants';
import Model from '../model';
import circle from './circle';
import rect from './rect';
import line from './line';
import polygon from './polygon';
import ellipse from './ellipse';

const shapes = { circle, rect, line, polygon, ellipse };

export default class ShapeHelper {
  static create(type, params) {
    return shapes[type].create(params);
  }

  static clone(unit, options) {
    const { keepPosition } = options;
    const json = unit.toJSON();
    if (!keepPosition) {
      if (unit.subtype === TYPE.LINE || unit.subtype === TYPE.POLYGON) {
        json.attributes.transform.e += 50;
        json.attributes.transform.f += 50;
      } else {
        json.attributes.position[0] += 50;
        json.attributes.position[1] += 50;
      }
    }
    json.uuid = Model.getUniqueIdStatic(json.type);
    return shapes[unit.subtype].fromJSON(json);
  }
}
